var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.998 1C7.98997 1 6.03997 3.019 3.73397 3.755C2.79597 4.055 2.32697 4.204 2.13697 4.415C1.94697 4.625 1.89197 4.934 1.78097 5.55C0.59097 12.146 3.19097 18.244 9.39097 20.618C10.056 20.873 10.389 21 11.001 21C11.613 21 11.947 20.872 12.613 20.617C18.812 18.244 21.409 12.146 20.219 5.55C20.108 4.934 20.052 4.625 19.862 4.414C19.672 4.203 19.204 4.054 18.266 3.755C15.959 3.019 14.006 1 10.998 1Z",
    stroke: "#2B3674",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25014 8.95897C9.25014 8.89897 9.25814 8.55297 9.26014 8.11897C9.26014 7.72097 9.22614 7.33897 9.41614 6.98897C10.1261 5.57497 12.1661 5.71897 12.6701 7.15897C12.7571 7.39597 12.7631 7.77097 12.7601 8.11897C12.7571 8.56197 12.7661 8.95897 12.7661 8.95897M9.33714 9.37997C8.25714 9.37997 7.71714 10.16 7.59714 10.64C7.47714 11.12 7.47714 12.86 7.54914 13.58C7.78914 14.48 8.38914 14.852 8.97714 14.972C9.51714 15.02 11.7971 15.002 12.4571 15.002C13.4171 15.02 14.1371 14.66 14.4371 13.58C14.4971 13.22 14.5571 11.24 14.4071 10.64C14.0891 9.67997 13.2971 9.37997 12.6971 9.37997H9.33714Z",
    stroke: "#2B3674",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.9449c703076b9f3d3bd6b1f5d58e8508.svg";
export { ForwardRef as ReactComponent };